import bulkUploadActions from '../actionTypes/bulkUploadActions';

const initialState = {
  isLoading: true,
  isSubmitting: false,
  isModalOpen: false,
};

const bulkUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case bulkUploadActions.bulkUpload:
      return { ...state, isSubmitting: true };
    case bulkUploadActions.bulkUploadSuccess:
      return {
        ...state,
        isSubmitting: false,
        errors: null,
        isModalOpen: false,
        data: null,
      };
    case bulkUploadActions.bulkUploadFailed:
      return { ...state, ...action.payload, isSubmitting: false };
    case bulkUploadActions.toggleModalState:
      return { ...state, isModalOpen: !state.isModalOpen };
    case bulkUploadActions.resetToInitialState:
      return initialState;
    case bulkUploadActions.getLastUploadDetails:
      return { ...state, isLoading: true };
    case bulkUploadActions.getLastUploadDetailsSuccess:
      return { ...state, ...action.payload, isLoading: false };
    case bulkUploadActions.getLastUploadDetailsFailed:
      return { ...state, isLoading: false, data: null, errors: [] };
    default:
      return state;
  }
};

export default bulkUploadReducer;
